import { provideSingleton } from '../../services/inversify';

@provideSingleton(TriggerService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service

export class TriggerService {
    private registerData: any = {};

    register(event: string, id: string, callback: (param?: any) => void) {
        this.prepare(event, id);
        // Zuerst schauen, ob wir schon die Callback-Funktion haben
        const idx = this.registerData[event][id].indexOf(callback);
        if (idx >= 0) {
            return; // gibts schon
        }
        this.registerData[event][id].push(callback);
    }
    hasRegistered(event: string, id: string) {
        return this.registerData[event] && this.registerData[event][id];
    }
    getRegisteredIds(event: string, filter?: string) {
        if (this.registerData[event]) {
            return Object.keys(this.registerData[event]).filter((id: string) => !filter || id.indexOf(filter) >= 0);
        }
    }
    unregister(event: string, id: string, callback: () => void) {
        this.prepare(event, id);
        const idx = this.registerData[event][id].indexOf(callback);
        if (idx >= 0) {
            this.registerData[event][id].splice(idx, 1);
        }
    }
    fire(event: string, id: string, param?: any) {
        if (event === 'reload') {
            //   console.trace('Trigger-Fire: ' + event + ' --> ' + id);
        }
        this.prepare(event, id);
        this.registerData[event][id].forEach((cb: (param?: any) => void) => cb(param));
    }
    prepare(event: string, id: string) {
        if (!this.registerData[event]) {
            this.registerData[event] = {};
        }
        if (!this.registerData[event][id]) {
            this.registerData[event][id] = [];
        }
    }
    clear() {
        this.registerData = {};
    }
    clearRegisteredId(event: string, id: string) {
        if (this.registerData[event]) {
            this.registerData[event][id] = [];
        }
    }
}
